import { Component, OnInit } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";

import { LoaderService } from "../service/loader.service";

@Component({
    selector: "kilowant-loader",
    templateUrl: "../../html/loader.html"
})
export class LoaderComponent implements OnInit {
    // Convert the observable to a signal, default to false
    show = toSignal(this.loaderService.loaderState, { initialValue: false });

    constructor(private loaderService: LoaderService) { }

    ngOnInit() {
        // No manual subscription needed � the signal automatically updates
    }
}